import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { tasksQueryOptions } from '@/features/tasks/api'
import { TasksWorkspace } from '@/features/tasks/pages/tasks-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/tasks/$taskId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(tasksQueryOptions(params.workspaceSlug)),
  component: TaskRoute,
})
function TaskRoute() {
  const { workspaceSlug, taskId } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <TasksWorkspace
      workspaceSlug={workspaceSlug}
      selectedTaskId={taskId}
      canWrite={workspace.data?.role !== 'viewer'}
    />
  )
}
